import React from "react";
import { Link, useLocation } from "react-router-dom";
import Button from "../ui/Button";
import BrandMark from "../ui/BrandMark";

export default function Landing() {
  const location = useLocation();
  const [showIntro, setShowIntro] = React.useState(false);
  const [isExiting, setIsExiting] = React.useState(false);

  React.useEffect(() => {
    const params = new URLSearchParams(location.search || "");
    const replay = params.get("intro") === "1";
    const seen = sessionStorage.getItem("landing_intro_seen") === "1";
    const shouldRun = replay || !seen;

    if (!shouldRun) {
      setShowIntro(false);
      setIsExiting(false);
      return;
    }

    setShowIntro(true);
    setIsExiting(false);

    const exitTimer = window.setTimeout(() => {
      setIsExiting(true);
    }, 1200);

    const doneTimer = window.setTimeout(() => {
      sessionStorage.setItem("landing_intro_seen", "1");
      setShowIntro(false);
      setIsExiting(false);
    }, 1800);

    return () => {
      window.clearTimeout(exitTimer);
      window.clearTimeout(doneTimer);
    };
  }, [location.search]);

  const handleSkip = () => {
    sessionStorage.setItem("landing_intro_seen", "1");
    setShowIntro(false);
    setIsExiting(false);
  };

  return (
    <div className="relative min-h-screen overflow-hidden bg-[linear-gradient(155deg,#070707_0%,#1f1f1f_40%,#bcbcbc_100%)]">
      {showIntro ? (
        <div
          className={`absolute inset-0 z-20 flex items-center justify-center bg-slate-950 text-white ${
            isExiting ? "intro-overlay-exit" : "intro-overlay-enter"
          }`}
        >
          <button
            type="button"
            className="absolute right-5 top-5 rounded-lg border border-white/20 bg-white/10 px-3 py-1.5 text-sm hover:bg-white/20"
            onClick={handleSkip}
          >
            Skip
          </button>
          <div className="flex flex-col items-center gap-4">
            <div className="rounded-2xl bg-white/95 px-4 py-3 shadow-[0_0_28px_rgba(255,255,255,0.35)]">
              <BrandMark size="lg" stacked />
            </div>
            <p className="text-center text-xs uppercase tracking-[0.18em] text-white/80 sm:text-sm">
              Created by W.I.S.E Wheeler Insurance Solutions and Expertise
            </p>
          </div>
        </div>
      ) : null}

      <main
        className="flex min-h-screen w-full items-center"
        style={{
          backgroundImage:
            "linear-gradient(100deg, rgba(255,255,255,0.94) 0%, rgba(255,255,255,0.9) 42%, rgba(0,0,0,0.38) 100%), url('https://images.unsplash.com/photo-1465800872432-9015f247bc91?auto=format&fit=crop&w=2200&q=80')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute right-4 top-4 z-10 rounded-md border border-zinc-300/80 bg-white/85 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.14em] text-zinc-700 backdrop-blur sm:right-6 sm:top-6 sm:text-xs">
          Created by W.I.S.E Wheeler Insurance Solutions and Expertise
        </div>
        <div className="w-full px-6 py-12 sm:px-10 lg:px-16">
          <div className="max-w-4xl">
            <BrandMark size="sm" className="mb-5" />
            <h1 className="text-4xl font-semibold tracking-tight text-zinc-900 sm:text-5xl lg:text-7xl">
              Build better estimates faster with a clean, reliable workflow
            </h1>
            <p className="mt-6 max-w-3xl text-base leading-relaxed text-zinc-700 sm:text-lg lg:text-xl">
              Upload photos, apply guideline logic, and deliver estimator-ready scope outputs in a clean workflow.
            </p>
            <div className="mt-10 flex flex-wrap gap-3">
              <Link to="/app/build">
                <Button>Build Estimate from Photos</Button>
              </Link>
              <Link to="/mitigation">
                <Button variant="secondary">Mitigation Station</Button>
              </Link>
              <Link to="/app/personal-property">
                <Button variant="secondary">Contents Corner</Button>
              </Link>
              <Link to="/app/review">
                <Button variant="secondary">Estimate Review</Button>
              </Link>
              <Link to="/pricing">
                <Button variant="ghost">View Pricing</Button>
              </Link>
            </div>
            <p className="mt-8 text-xs uppercase tracking-[0.16em] text-zinc-600">
              Field photos to scoped estimate in minutes
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
